import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Component } from 'react';
import MediaImageV2WithMediaClient from './mediaImageV2WithMediaClient';
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError(_) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    // TODO: handle error
    // console.error('Uncaught error:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
const MediaImageWithErrorBoundary = props => {
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: props.children({
      loading: false,
      error: true
    })
  }, /*#__PURE__*/React.createElement(MediaImageV2WithMediaClient, props));
};
export default MediaImageWithErrorBoundary;